var ListState = (() => {
    var _this, CONFIG;

    CONFIG = {
        ATTACH_TIMEOUT: 3000,
        ATTACH_INTERVAL: 16
    };

    function whenAttached($element) {
        return new Promise(resolve => {
            let startTime;

            startTime = Date.now();

            (function check() {
                let element;

                element = $element ? $element[0] : null;

                if (!element || element.isConnected || ((Date.now() - startTime) > CONFIG.ATTACH_TIMEOUT)) {
                    resolve(!!(element && element.isConnected));
                    return;
                }

                setTimeout(check, CONFIG.ATTACH_INTERVAL);
            })();
        });
    }

    function stableStringify(value) {
        if (Array.isArray(value)) {
            return `[${value.map(stableStringify).join(',')}]`;
        }

        if (value && (typeof value === 'object')) {
            return `{${Object.keys(value).sort().map(key => `${JSON.stringify(key)}:${stableStringify(value[key])}`).join(',')}}`;
        }

        return JSON.stringify(value);
    }

    _this = {
        create: function(limit) {
            let entries, keys;

            entries = {};
            keys = [];

            return {
                get: function(key) {
                    if (!entries.hasOwnProperty(key)) {
                        entries[key] = {
                            items: null,
                            scrollTop: 0
                        };
                    }

                    keys = keys.filter(existingKey => (existingKey !== key));
                    keys.push(key);

                    while (keys.length > limit) {
                        delete entries[keys.shift()];
                    }

                    return entries[key];
                }
            };
        },
        isEqual: function(valueA, valueB) {
            return (stableStringify(valueA) === stableStringify(valueB));
        },
        whenAttached: whenAttached,
        restoreScrollTop: function($view, scrollTop) {
            return whenAttached($view).then(isAttached => {
                if (!isAttached || !scrollTop) {
                    return;
                }

                return AnimationHandler.scrollTo(scrollTop, true);
            });
        }
    };

    return _this;
})();
